import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ScreenType } from 'src/app/enums/ScreenType';
import { visitorTable } from 'src/app/models/table/visitorTable';
import { Visitor } from 'src/app/models/visitor';
import {
  getSelectedDateVisitorTableData,
  organizeVisitorTableData,
} from 'src/app/utils/table-utils';

@Component({
  selector: 'app-expected-visitor',
  templateUrl: './expected-visitor.component.html',
  styleUrls: ['./expected-visitor.component.scss'],
})
export class ExpectedVisitorComponent implements AfterViewInit {
  @Input() set selectedDate(date: Date) {
    if (date) this.setTableData(date);
  }
  @Input() set visitorData(val: Visitor[]) {
    if (val) this.setVisitorData(val);
  }

  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }

  @Output() showVisitorDetail = new EventEmitter<any>();
  expectedVisitors: Visitor[];
  screenInfo: ScreenType;
  tempDate: Date;
  filteredDataSource: MatTableDataSource<Visitor>;
  temp: visitorTable[];
  filter: Visitor[];
  displayedColumns = [
    'name',
    'date',
    'time',
    'host',
    'purpose',
    'security',
    'Details',
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor() {}
  ngAfterViewInit() {
    this.filteredDataSource.paginator = this.paginator;
    this.filteredDataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredDataSource.filter = filterValue.trim().toLowerCase();

    if (this.filteredDataSource.paginator) {
      this.filteredDataSource.paginator.firstPage();
    }
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.displayedColumns,
      event.previousIndex,
      event.currentIndex
    );
  }
  expandedElement: any = null;
  onShowDetails(val: Visitor) {
    this.expandedElement =
      this.expandedElement === val.visitorID ? null : val.visitorID;
    this.showVisitorDetail.emit(val);
  }
  setTableData(date: Date) {
    this.tempDate = date;
    if (date) {
      this.filter = getSelectedDateVisitorTableData(
        new Date(date),
        this.expectedVisitors
      );
      // this.temp = organizeVisitorTableData(this.filter);
      this.filteredDataSource = new MatTableDataSource(this.filter);
    }
  }
  setVisitorData(val: Visitor[]) {
    // this.expectedVisitors = val.filter((item) => item.isGateEntry == '0');
    this.expectedVisitors = val;
    this.filteredDataSource = new MatTableDataSource(this.expectedVisitors);
  }
  getFormatedDate(val: any) {
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
  ScreenType = ScreenType;
}
